<template>
   <div>
       <div class="kit__utils__heading">
         <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
       </div>
       <div class="card">
         <div class="card-header">
            <!-- <b-row> -->
               <b-col cols="6" md="8">
                <b-form-group label-cols-sm="3" label="เลือกวันที่" class="mb-2">
                  <b-tabs content-class="mt-3" fill v-model="tabIndex">
                    <b-tab title="วัน" active>
                      <b-row>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-date-picker v-model="form.startDate" :disabled-date="disabledStartDate"
                              format="YYYY-MM-DD" placeholder="วันที่เริ่มต้น" style="width: 100%"
                              @openChange="handleStartOpenChange" @change="setDate" />
                          </a-config-provider>
                        </b-col>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-date-picker v-model="form.endDate" :disabled-date="disabledEndDate" format="YYYY-MM-DD"
                              placeholder="วันที่สิ้นสุด" :open="endOpen" style="width: 100%"
                              @openChange="handleEndOpenChange" @change="setDate" />
                          </a-config-provider>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab title="เดือน">
                      <b-row>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-month-picker v-model="form.startMouth" :disabled-date="disabledStartMouth"
                              format="YYYY-MM" placeholder="เดือนเริ่มต้น" style="width: 100%"
                              @openChange="handleStartMouth" @change="setMonth" />
                          </a-config-provider>
                        </b-col>
                        <b-col cols="12" md="6">
                          <a-config-provider :locale="locale">
                            <a-month-picker v-model="form.endMouth" :disabled-date="disabledEndMouth" format="YYYY-MM"
                              placeholder="เดือนสิ้นสุด" :open="endOpenMouth" style="width: 100%"
                              @openChange="handleEndMouth" @change="setMonth" />
                          </a-config-provider>
                        </b-col>
                      </b-row>
                    </b-tab>
                  </b-tabs>
                </b-form-group>
              </b-col>
               <!-- <b-col cols="6" md="8">
                     <b-form-group label-cols-sm="3" label="ประเภทบัญชี" class="mb-12">
                      <a-select  show-search placeholder="กรุณาเลือกข้อมูล" style="width: 100%"
                        @select="setBanktype">
                        <a-select-option value="1">
                          บัญชีรับ
                        </a-select-option>
                        <a-select-option value="2">
                          บัญชีถอน
                        </a-select-option>
                        <a-select-option value="3">
                          บัญชีถอนเงินคืนลูกค้า
                        </a-select-option>
                        <a-select-option value="4">
                          บัญชีถอนเงินค่าคอมมิชชั่น
                        </a-select-option>
                      </a-select>
                    </b-form-group>
              </b-col> -->
               <b-col cols="6" md="12" >
                <b-col>
                  <b-col>
                    <b-form-group label-cols-sm="10">
                    <div class="d-flex flex-column justify-content-right ">
                      <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                          class="fe fe-rotate-cw mr-1" /> ตรวจสอบ</a>
                    </div>
                    </b-form-group>
                  </b-col>
                </b-col>
              </b-col>
            <!-- </b-row> -->
          </div>
         <div class="card-body">
           <b-col cols="3" md="2">
             <div class="d-flex flex-column justify-content-center mr-auto">
               <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
                 <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
                   v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
                 </b-dropdown-item>
                  <b-dropdown-item @click="checkDataExcel(json_data)">
                   <download-excel :data="json_data" :fields="json_fields" :name="fileName">
                     <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                   </download-excel>
                 </b-dropdown-item>
                 <b-dropdown-item>
                   <download-excel :data="dataExport" :fields="json_fields" :name="fileName">
                     <i class="fa fa-file-excel-o mr-1" />Export Excel All
                   </download-excel>
                 </b-dropdown-item> <!---->
               </b-dropdown>
             </div>
           </b-col>
           <a-table :columns="columns" :data-source="dataTable" bordered size="middle" :row-selection="rowSelection" rowKey='bankSetID' :pagination="false" :scroll="{ x: 'calc(700px + 50%)', y: 500 }" >
            <a slot="name" slot-scope="text, record" >{{record.name}}    </a>
            <a slot="DepositKbank" slot-scope="text, record" :style="setColor('Deposit')">{{setComma(record.paymentDepositKbank)}}</a>
            <a slot="WithdrawalKbank" slot-scope="text, record" :style="setColor('Withdrawal')">{{setComma(record.paymentWithdrawalKbank)}}</a>
            <a slot="DepositScb" slot-scope="text, record" :style="setColor('Deposit')">{{setComma(record.paymentDepositScb)}}</a>
            <a slot="WithdrawalScb" slot-scope="text, record" :style="setColor('Withdrawal')">{{setComma(record.paymentWithdrawalScb)}}</a>
            <a slot="DepositKtb" slot-scope="text, record" :style="setColor('Deposit')">{{setComma(record.paymentDepositKtb)}}</a>
            <a slot="WithdrawalKtb" slot-scope="text, record" :style="setColor('Withdrawal')">{{setComma(record.paymentWithdrawalKtb)}}</a>
            <a slot="DepositBay" slot-scope="text, record" :style="setColor('Deposit')">{{setComma(record.paymentDepositBay)}}</a>
            <a slot="WithdrawalBay" slot-scope="text, record" :style="setColor('Withdrawal')">{{setComma(record.paymentWithdrawalBay)}}</a>
            <a slot="DepositAll" slot-scope="text, record" :style="setColor('Deposit')">{{setComma(record.sumpaymentDeposit)}}</a>
            <a slot="WithdrawalAll" slot-scope="text, record" :style="setColor('Withdrawal')">{{setComma(record.sumpaymentWithdrawal)}}</a>
            <a slot="totalScb" slot-scope="text, record">{{setComma(record.sumpaymentScb)}}  <a v-if="record.name !== 'รวม'" class="btn btn-primary" href="javascript: void(0);" @click="getBankset(record.bankSetID,'scb')"><i class="fa fa-search" /></a></a>
            <a slot="totalKbank" slot-scope="text, record">{{setComma(record.sumpaymentKbank)}}  <a v-if="record.name !== 'รวม'" class="btn btn-primary" href="javascript: void(0);" @click="getBankset(record.bankSetID,'kbank')"><i class="fa fa-search" /></a></a>
            <a slot="totalKtb" slot-scope="text, record">{{setComma(record.sumpaymentKtb)}}  <a v-if="record.name !== 'รวม'" class="btn btn-primary" href="javascript: void(0);" @click="getBankset(record.bankSetID,'ktb')"><i class="fa fa-search" /></a></a>
            <a slot="totalBay" slot-scope="text, record">{{setComma(record.sumpaymentBay)}}  <a v-if="record.name !== 'รวม'" class="btn btn-primary" href="javascript: void(0);" @click="getBankset(record.bankSetID,'bay')"><i class="fa fa-search" /></a></a>
            <span slot="bankType" slot-scope="text">
            <a-tag v-if="text !== 99" :color="(text === 1)?'green':'red'">
                {{(text === 1)?'บัญชีรับ':(text === 2)?'บัญชีถอน':(text === 3)?'บัญชีถอนคืนลูกค้า':(text === 4)?'บัญชีถอนคอมมิชชั่น':(text === 5)?'บัญชีกดตู้':"ไม่พบข้อมํูล"}}
            </a-tag>
          </span>
            </a-table>
         </div>
       </div>
      <div class="card">
          <div class="card-body">
            <b-col cols="3" md="2" :style="displayDetailExport(displayExport)">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
                <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedDetailRowKeys)"
                  v-clipboard:success="onCopyDetail" v-clipboard:error="onErrorDetail"><i
                    class="fa fa-copy mr-1" />Copy!
                </b-dropdown-item>
                <b-dropdown-item @click="checkDataExcel(json_data_detail)">
                  <download-excel :data="json_data_detail" :fields="json_fields_detail" :name="fileNameDetail">
                    <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                  </download-excel>
                </b-dropdown-item>
                <b-dropdown-item>
                  <download-excel :data="dataDetailExport" :fields="json_fields_detail" :name="fileNameDetail">
                    <i class="fa fa-file-excel-o mr-1" />Export Excel All
                  </download-excel>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-col>
           <a-table :columns="columnsDetail" :data-source="dataDetail" bordered size="middle" :row-selection="rowSelectionDetail" rowKey='id' :scroll="{ x: 'calc(700px + 50%)', y: 500 }" >
            <a slot="amountIn" slot-scope="text, record" :style="setColor('Deposit')">{{setComma(record.amountIn)}}</a>
            <a slot="amountOut" slot-scope="text, record" :style="setColor('Withdrawal')">{{setComma(record.amountOut)}}</a>
            <a slot="balance" slot-scope="text, record">{{setComma(record.balance)}}</a>
            <h6 slot="status" slot-scope="status">
              <b-badge :variant="getStatus('bankPayment',status).color">{{getStatus('bankPayment',status).name}}</b-badge>
            </h6>
            </a-table>
         </div>
      </div>
    </div>
</template>
<script>
import apiClient from '@/services/api'
import { getName } from '@/utils/status'
import Swal from 'sweetalert2'
import thTH from 'ant-design-vue/es/locale/th_TH'
import moment from 'moment'
import momentTz from 'moment-timezone'
import 'moment/locale/th'
moment.locale('th')
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}

export default {
  data() {
    return {
      locale: thTH,
      thTH,
      displayExport: false,
      dataTable: [],
      dataDetail: [],
      dataExport: [],
      dataDetailExport: [],
      fileName: 'รายงานบัญชี' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
      fileNameDetail: 'รายงานรายการบัญชี' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
      json_data: [],
      json_fields: {
        ชื่อ: 'name',
        ประเภทบัญชี: 'bankType',
        'ฝากเข้า(scb)': 'paymentDepositScb',
        'ถอนออก(scb)': 'paymentWithdrawalScb',
        'คงเหลือ(scb)': 'sumpaymentScb',
        'ฝากเข้า(kbank)': 'paymentDepositKbank',
        'ถอนออก(kbank)': 'paymentWithdrawalKbank',
        'คงเหลือ(kbank)': 'sumpaymentKbank',
        'ฝากเข้า(ktb)': 'paymentDepositKtb',
        'ถอนออก(ktb)': 'paymentWithdrawalKtb',
        'คงเหลือ(ktb)': 'sumpaymentKtb',
        'ฝากเข้า(Bay)': 'paymentDepositBay',
        'ถอนออก(Bay)': 'paymentWithdrawalBay',
        'คงเหลือ(Bay)': 'sumpaymentBay',
        ฝากรวม: 'sumpaymentDeposit',
        ถอนรวม: 'sumpaymentWithdrawal',
        คงเหลือ: 'sumpaymentAll',
      },
      json_data_detail: [],
      json_fields_detail: {
        ชื่อ: 'accountName',
        บัญชีธนาคาร: 'bankServiceSystem',
        เวลา: 'datetimeTranfer',
        ฝาก: 'amountIn',
        ถอน: 'amountOut',
        คงเหลือ: 'balance',
        สถานะ: 'status',
        ช่องทางทำธุรกรรม: 'channel',
        รายละเอียด: 'detail',
        วันที่สร้าง: 'createdAt',
        วันที่อัปเดท: 'updatedAt',
      },
      form: {
        startDate: moment().subtract(1, 'days'),
        endDate: moment().subtract(1, 'days'),
        startMouth: moment(),
        endMouth: moment(),
      },
      endOpen: false,
      endOpenMouth: false,
      tabIndex: 1,
      selectedRowKeys: [],
      selectedDetailRowKeys: [],
      columns: [{
        title: 'ชื่อ',
        dataIndex: 'name',
        align: 'center',
        key: 'name',
        fixed: 'left',
        width: 200,
        scopedSlots: { customRender: 'name' },
      },
      {
        title: 'คู่ค้า',
        key: 'operatorName',
        dataIndex: 'operatorName',
        align: 'center',
        fixed: 'left',
        width: 200,
      },
      {
        title: 'ประเภทบัญชี',
        dataIndex: 'bankType',
        align: 'center',
        key: 'bankType',
        fixed: 'left',
        width: 150,
        scopedSlots: { customRender: 'bankType' },
      },
      {
        title: 'ธนาคาร',
        children: [{
          title: 'SCB',
          className: 'SCB',
          children: [{
            title: 'ฝากเข้า',
            className: 'SCB',
            align: 'right',
            dataIndex: 'paymentDepositScb',
            key: 'paymentDepositScb',
            width: 100,
            scopedSlots: { customRender: 'DepositScb' },
          },
          {
            title: 'ถอนออก',
            className: 'SCB',
            dataIndex: 'paymentWithdrawalScb',
            key: 'paymentWithdrawalScb',
            align: 'right',
            width: 100,
            scopedSlots: { customRender: 'WithdrawalScb' },
          },
          {
            title: 'คงเหลือ',
            className: 'SCB',
            dataIndex: 'sumpaymentScb',
            key: 'sumpaymentScb',
            align: 'right',
            width: 150,
            scopedSlots: { customRender: 'totalScb' },
          },
          ],
        },
        {
          title: 'KBANK',
          dataIndex: 'age',
          className: 'KBANK',
          children: [{
            title: 'ฝากเข้า',
            className: 'KBANK',
            dataIndex: 'paymentDepositKbank',
            key: 'paymentDepositKbank',
            align: 'right',
            width: 100,
            scopedSlots: { customRender: 'DepositKbank' },
          },
          {
            title: 'ถอนออก',
            className: 'KBANK',
            dataIndex: 'paymentWithdrawalKbank',
            key: 'paymentWithdrawalKbank',
            align: 'right',
            width: 100,
            scopedSlots: { customRender: 'WithdrawalKbank' },
          },
          {
            title: 'คงเหลือ',
            className: 'KBANK',
            dataIndex: 'sumpaymentKbank',
            key: 'sumpaymentKbank',
            align: 'right',
            width: 150,
            scopedSlots: { customRender: 'totalKbank' },
          },
          ],
        },
        {
          title: 'KTB',
          className: 'KTB',
          children: [{
            title: 'ฝากเข้า',
            className: 'KTB',
            dataIndex: 'paymentDepositKtb',
            key: 'paymentDepositKtb',
            align: 'right',
            width: 100,
            scopedSlots: { customRender: 'DepositKtb' },
          },
          {
            title: 'ถอนออก',
            className: 'KTB',
            dataIndex: 'paymentWithdrawalKtb',
            key: 'paymentWithdrawalKtb',
            align: 'right',
            width: 100,
            scopedSlots: { customRender: 'WithdrawalKtb' },
          },
          {
            title: 'คงเหลือ',
            className: 'KTB',
            dataIndex: 'sumpaymentKtb',
            key: 'sumpaymentKtb',
            align: 'right',
            width: 150,
            scopedSlots: { customRender: 'totalKtb' },
          },
          ],
        },
        {
          title: 'BAY',
          className: 'BAY',
          children: [{
            title: 'ฝากเข้า',
            className: 'BAY',
            dataIndex: 'paymentDepositBay',
            key: 'paymentDepositBay',
            align: 'right',
            width: 100,
            scopedSlots: { customRender: 'DepositBay' },
          },
          {
            title: 'ถอนออก',
            className: 'BAY',
            dataIndex: 'paymentWithdrawalBay',
            key: 'paymentWithdrawalBay',
            align: 'right',
            width: 100,
            scopedSlots: { customRender: 'WithdrawalBay' },
          },
          {
            title: 'คงเหลือ',
            className: 'BAY',
            dataIndex: 'sumpaymentBay',
            key: 'sumpaymentBay',
            align: 'right',
            width: 150,
            scopedSlots: { customRender: 'totalBay' },
          },
          ],
        },
        ],
      },
      {
        title: 'ฝากรวม',
        dataIndex: 'sumpaymentDeposit',
        key: 'sumpaymentDeposit',
        align: 'right',
        width: 100,
        fixed: 'right',
        scopedSlots: { customRender: 'DepositAll' },
      },
      {
        title: 'ถอนรวม',
        dataIndex: 'sumpaymentWithdrawal',
        key: 'sumpaymentWithdrawal',
        width: 100,
        align: 'right',
        fixed: 'right',
        scopedSlots: { customRender: 'WithdrawalAll' },
      },
      {
        title: 'คงเหลือ',
        dataIndex: 'sumpaymentAll',
        key: 'sumpaymentAll',
        width: 100,
        align: 'right',
        fixed: 'right',
        customRender: (text, row, index) => {
          if (text !== null && typeof text !== 'undefined') {
            return text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          } else {
            return 0.00
          }
        },
      },
      ],
      columnsDetail: [
        {
          title: 'Id',
          dataIndex: 'id',
          // width: '25%',
          // scopedSlots: { customRender: 'accountName' },
        },
        {
          title: 'ชื่อ',
          dataIndex: 'accountName',
          scopedSlots: { customRender: 'accountName' },
        },
        {
          title: 'บัญชีธนาคาร',
          dataIndex: 'bankServiceSystem',
          scopedSlots: { customRender: 'bankServiceSystem' },
        },
        {
          title: 'เวลา',
          dataIndex: 'datetimeTranfer',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
        {
          title: 'ฝาก',
          dataIndex: 'amountIn',
          align: 'right',
          width: '8%',
          scopedSlots: { customRender: 'amountIn' },
        },
        {
          title: 'ถอน',
          dataIndex: 'amountOut',
          align: 'right',
          width: '8%',
          scopedSlots: { customRender: 'amountOut' },
        },
        {
          title: 'คงเหลือ',
          dataIndex: 'balance',
          align: 'right',
          width: '8%',
          scopedSlots: { customRender: 'balance' },
        },
        {
          title: 'สถานะ',
          dataIndex: 'status',
          align: 'right',
          width: '8%',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'ช่องทางทำธุรกรรม',
          dataIndex: 'channel',
        },
        {
          title: 'รายละเอียด',
          dataIndex: 'detail',
          scopedSlots: { customRender: 'detail' },
        },
        {
          title: 'วันที่สร้าง',
          dataIndex: 'createdAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
        {
          title: 'วันที่อัปเดท',
          dataIndex: 'updatedAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
      ],
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataTable.map((result) => {
                return result.id
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
    rowSelectionDetail() {
      const { selectedDetailRowKeys } = this
      return {
        selectedDetailRowKeys,
        onChange: this.onSelectDetailChange,
        hideDefaultSelections: true,

        // selections: [
        //   {
        //     key: 'all-data',
        //     text: 'เลือกทั้งหมด',
        //     onSelect: () => {
        //       this.selectedDetailRowKeys = this.dataDetail.map((result) => {
        //         return result.id
        //       })
        //     },
        //   },
        //   {
        //     key: 'del-data',
        //     text: 'ลบทั้งหมด',
        //     onSelect: () => {
        //       this.selectedDetailRowKeys = []
        //     },
        //   },
        // ],
        onSelection: this.onSelection,
      }
    },
  },
  watch: {
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
    selectedDetailRowKeys: function(val) {
      if (val) {
        this.dataDetailToExcel(val)
      }
    },
  },
  methods: {
    checkDataExcel (data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    dataToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = {
            name: item.name,
            bankType: this.bankType(item.bankType),
            paymentDepositScb: this.setComma(item.paymentDepositScb),
            paymentWithdrawalScb: this.setComma(item.paymentWithdrawalScb),
            sumpaymentScb: this.setComma(item.sumpaymentScb),
            paymentDepositKbank: this.setComma(item.paymentDepositKbank),
            paymentWithdrawalKbank: this.setComma(item.paymentWithdrawalKbank),
            sumpaymentKbank: this.setComma(item.sumpaymentKbank),
            paymentDepositKtb: this.setComma(item.paymentDepositKtb),
            paymentWithdrawalKtb: this.setComma(item.paymentWithdrawalKtb),
            sumpaymentKtb: this.setComma(item.sumpaymentKtb),
            paymentDepositBay: this.setComma(item.paymentDepositBay),
            paymentWithdrawalBay: this.setComma(item.paymentWithdrawalBay),
            sumpaymentBay: this.setComma(item.sumpaymentBay),
            sumpaymentDeposit: this.setComma(item.sumpaymentDeposit),
            sumpaymentWithdrawal: this.setComma(item.sumpaymentWithdrawal),
            sumpaymentAll: this.setComma(item.sumpaymentAll),
          }
          dataresult.push(resultData)
        })
        this.json_data = dataresult
      }
    },
    exportAll (obj) {
      this.dataExport = []
      let resultData = {}
      obj.map(element => {
        resultData = {
          name: element.name,
          bankType: this.bankType(element.bankType),
          paymentDepositScb: this.setComma(element.paymentDepositScb),
          paymentWithdrawalScb: this.setComma(element.paymentWithdrawalScb),
          sumpaymentScb: this.setComma(element.sumpaymentScb),
          paymentDepositKbank: this.setComma(element.paymentDepositKbank),
          paymentWithdrawalKbank: this.setComma(element.paymentWithdrawalKbank),
          sumpaymentKbank: this.setComma(element.sumpaymentKbank),
          paymentDepositKtb: this.setComma(element.paymentDepositKtb),
          paymentWithdrawalKtb: this.setComma(element.paymentWithdrawalKtb),
          sumpaymentKtb: this.setComma(element.sumpaymentKtb),
          paymentDepositBay: this.setComma(element.paymentDepositBay),
          paymentWithdrawalBay: this.setComma(element.paymentWithdrawalBay),
          sumpaymentBay: this.setComma(element.sumpaymentBay),
          sumpaymentDeposit: this.setComma(element.sumpaymentDeposit),
          sumpaymentWithdrawal: this.setComma(element.sumpaymentWithdrawal),
          sumpaymentAll: this.setComma(element.sumpaymentAll),
        }
        this.dataExport.push(resultData)
      })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = {
            name: item.name,
            bankType: this.bankType(item.bankType),
            paymentDepositScb: this.setComma(item.paymentDepositScb),
            paymentWithdrawalScb: this.setComma(item.paymentWithdrawalScb),
            sumpaymentScb: this.setComma(item.sumpaymentScb),
            paymentDepositKbank: this.setComma(item.paymentDepositKbank),
            paymentWithdrawalKbank: this.setComma(item.paymentWithdrawalKbank),
            sumpaymentKbank: this.setComma(item.sumpaymentKbank),
            paymentDepositKtb: this.setComma(item.paymentDepositKtb),
            paymentWithdrawalKtb: this.setComma(item.paymentWithdrawalKtb),
            sumpaymentKtb: this.setComma(item.sumpaymentKtb),
            paymentDepositBay: this.setComma(item.paymentDepositBay),
            paymentWithdrawalBay: this.setComma(item.paymentWithdrawalBay),
            sumpaymentBay: this.setComma(item.sumpaymentBay),
            sumpaymentDeposit: this.setComma(item.sumpaymentDeposit),
            sumpaymentWithdrawal: this.setComma(item.sumpaymentWithdrawal),
            sumpaymentAll: this.setComma(item.sumpaymentAll),
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    dataDetailToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataDetail.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = {
            accountName: item.accountName,
            bankServiceSystem: item.bankServiceSystem,
            datetimeTranfer: moment(item.datetimeTranfer).format('DD/MM/YYYY HH:mm:ss'),
            amountIn: this.setComma(item.amountIn),
            amountOut: this.setComma(item.amountOut),
            balance: this.setComma(item.balance),
            status: this.getStatus('bankPayment', item.status).name,
            channel: item.channel,
            detail: item.detail,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            updatedAt: moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          dataresult.push(resultData)
        })
        this.json_data_detail = dataresult
      }
    },
    exportDetailAll (obj) {
      this.dataDetailExport = []
      let resultData = {}
      obj.map(element => {
        resultData = {
          accountName: element.accountName,
          bankServiceSystem: element.bankServiceSystem,
          datetimeTranfer: moment(element.datetimeTranfer).format('DD/MM/YYYY HH:mm:ss'),
          amountIn: this.setComma(element.amountIn),
          amountOut: this.setComma(element.amountOut),
          balance: this.setComma(element.balance),
          status: this.getStatus('bankPayment', element.status).name,
          channel: element.channel,
          detail: element.detail,
          createdAt: moment(element.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          updatedAt: moment(element.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
        }
        this.dataDetailExport.push(resultData)
      })
    },
    onCopyDetail: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataDetail.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = {
            accountName: item.accountName,
            bankServiceSystem: item.bankServiceSystem,
            datetimeTranfer: moment(item.datetimeTranfer).format('DD/MM/YYYY HH:mm:ss'),
            amountIn: this.setComma(item.amountIn),
            amountOut: this.setComma(item.amountOut),
            balance: this.setComma(item.balance),
            status: this.getStatus('bankPayment', item.status).name,
            channel: item.channel,
            detail: item.detail,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            updatedAt: moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onErrorDetail: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectDetailChange(selectedDetailRowKeys) {
      this.selectedDetailRowKeys = selectedDetailRowKeys
    },
    refreshData() {
      this.setDate()
    },
    // setBanktype(bankType) {
    //   const startDate = (this.form.startDate) ? this.form.startDate.format('YYYY/MM/DD 00:00:00') : moment().format('YYYY/MM/DD 00:00:00')
    //   const endDate = (this.form.endDate) ? this.form.endDate.format('YYYY/MM/DD 23:59:59') : moment().format('YYYY/MM/DD 23:59:59')

    //   this.setDateRank(startDate, endDate, bankType)
    // },
    async getData() {
      await apiClient.post('/reportBank/getDataATM').then(response => {
        const res = response.data
        if (res.code === '000') {
          this.dataTable = res.responseData.data
        } else {
          this.dataTable = []
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    bankType(item) {
      const typeName = (item === 1) ? 'บัญชีรับ' : (item === 2) ? 'บัญชีถอน' : (item === 3) ? 'บัญชีถอนคืนลูกค้า' : (item === 4) ? 'บัญชีถอนคอมมิชชั่น' : (item === 99) ? '' : (item === 5) ? 'บัญชีกดตู้' : 'ไม่พบข้อมูล'
      return typeName
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    setComma(value) {
      if (value !== null && typeof value !== 'undefined') {
        return value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return 0.00
      }
    },
    setColor(value) {
      if (value === 'Deposit') {
        return 'color: #14ab84'
      } else {
        return 'color: #f04e3f'
      }
    },
    async getBankset(bankSetID, bankType) {
      const startDate = (this.tabIndex === 0) ? (this.form.startDate) ? this.form.startDate.format('YYYY/MM/DD 00:00:00') : moment().format('YYYY/MM/DD 00:00:00') : (this.form.startMouth) ? this.form.startMouth.startOf('month').format('YYYY/MM/DD 00:00:00') : moment().startOf('month').format('YYYY/MM/DD 00:00:00')
      const endDate = (this.tabIndex === 0) ? (this.form.endDate) ? this.form.endDate.format('YYYY/MM/DD 23:59:59') : moment().format('YYYY/MM/DD 23:59:59') : (this.form.endMouth) ? this.form.endMouth.endOf('month').format('YYYY/MM/DD 23:59:59') : moment().endOf('month').format('YYYY/MM/DD 23:59:59')
      const sentData = {
        bankSetID: bankSetID,
        startDate: startDate,
        endDate: endDate,
        bankType: bankType,
      }
      await apiClient.post('/reportBank/getDataBankSetATM', sentData).then(response => {
        if (response.data.code === '000') {
          this.dataDetail = response.data.responseData.data
          this.exportDetailAll(response.data.responseData.data)
          this.displayExport = true
        } else {
          const iconError = (response.data.code !== '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: 'ไม่พบข้อมูล' })
          this.dataDetail = []
          this.displayExport = false
        }
      }).catch(error => {
        Swal.showValidationMessage(
              `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    displayDetailExport(val) {
      const result = (val === true) ? 'display: block' : 'display: none'
      return result
    },
    async setDateRank(startDate, endDate) {
      const sentData = {
        startDate: startDate,
        endDate: endDate,
        // bankType: bankType,
      }
      await apiClient.post('/reportBank/getDataSearchATM', sentData).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.dataTable = res.responseData.data
          this.exportAll(res.responseData.data)
          this.dataDetail = []
        } else {
          this.dataTable = []
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    setDate() {
      const startDate = (this.form.startDate) ? this.form.startDate.format('YYYY/MM/DD 00:00:00') : moment().format('YYYY/MM/DD 00:00:00')
      const endDate = (this.form.endDate) ? this.form.endDate.format('YYYY/MM/DD 23:59:59') : moment().format('YYYY/MM/DD 23:59:59')
      // const bankType = 0
      this.setDateRank(startDate, endDate)
    },
    setMonth() {
      const startDate = (this.form.startMouth) ? this.form.startMouth.startOf('month').format('YYYY/MM/DD 00:00:00') : moment().startOf('month').format('YYYY/MM/DD 00:00:00')
      const endDate = (this.form.endMouth) ? this.form.endMouth.endOf('month').format('YYYY/MM/DD 23:59:59') : moment().endOf('month').format('YYYY/MM/DD 23:59:59')
      // const bankType = 0
      this.setDateRank(startDate, endDate)
    },
    disabledStartDate(startDate) {
      const endDate = this.form.endDate
      if (!startDate || !endDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    disabledEndDate(endDate) {
      const startDate = this.form.startDate

      if (!endDate || !startDate) {
        return false
      }
      return startDate.valueOf() > endDate.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    disabledStartMouth(startMouth) {
      const endMouth = this.form.endMouth
      if (!startMouth || !endMouth) {
        return false
      }
      return startMouth.valueOf() > endMouth.valueOf()
    },
    disabledEndMouth(endMouth) {
      const startMouth = this.form.startMouth
      if (!endMouth || !startMouth) {
        return false
      }
      return startMouth.valueOf() > endMouth.valueOf()
    },
    handleStartMouth(open) {
      if (!open) {
        this.endOpenMouth = true
      }
    },
    handleEndMouth(open) {
      this.endOpenMouth = open
    },
  },
  clearSearch() {
    this.form = {
      startDate: moment().subtract(1, 'days'),
      endDate: moment().subtract(1, 'days'),
      startMouth: moment(),
      endMouth: moment(),
    }
  },
  async created() {
    await this.getData()
    await this.setDate()
  },
}
</script>
<style>
.my-table .ant-table-thead {
   background: red;
}

[data-kit-theme="dark"] .ant-table-thead > tr > .SCB  {
  color: #ffffff;
  background: rgb(122, 88, 191);
}

[data-kit-theme="default"] .ant-table-thead > tr > .SCB {
  color: #ffffff;
  background: rgb(122, 88, 191);
}
[data-kit-theme="dark"] .ant-table-thead > tr > .KBANK  {
  color: #ffffff;
  background: #00a950;
}

[data-kit-theme="default"] .ant-table-thead > tr > .KBANK {
  color: #ffffff;
  background: #00a950;
}
[data-kit-theme="dark"] .ant-table-thead > tr > .KTB  {
  color: #ffffff;
  background: #00A4E4;
}

[data-kit-theme="default"] .ant-table-thead > tr > .KTB {
  color: #ffffff;
  background: #00A4E4;
}

[data-kit-theme="dark"] .ant-table-thead > tr > .BAY  {
  color: #ffffff;
  background: #ffd400;
}

[data-kit-theme="default"] .ant-table-thead > tr > .BAY {
  color: #ffffff;
  background: #ffd400;
}

</style>
